export default IconBrandKotlin => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-kotlin" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20 20h-16v-16h16" />
  <path d="M4 20l16 -16" />
  <path d="M4 12l8 -8" />
  <path d="M12 12l8 8" />
</svg>`;